<style lang="less">
	@import '../../style/variable.less';
	.tk-detail-audio{
		.tk-detail-audio-item{
			width:calc(100vw/4);
			height:calc(100vw/8);
			background:@default_bg_color;
			>div{
				height:100%;
				width:100%;
			}
		}
	}
</style>
<template>
	<div class="tk-detail-audio">
		<div 
			v-for="item of list"
			class="tk-detail-audio-item">
			<div @click="playAudio(item.src,item.id)">
				
			</div>
		</div>
	</div>
</template>

<script>
	import playAudio from '../upload-audio/playAudio.js';
	export default {
		props:{
			list:{
				type:Array,
				default:()=>[]
			}
		},
		methods:{
			playAudio(src,id){
				playAudio(src)
			}
		}
	}
</script>

